import { type MentionItemType } from './types';

export const MENTION_SUGGESTION_LISTBOX_ID = 'mention-suggestion-listbox';

export const BOARD_MENTION_ASSETS_KEY = 'BOARD_MENTION_ASSETS';

export const MENTION_THUMBNAIL_SIZE = 32;

export const CANVAS_HIGHLIGHT_MENTION_TYPES: ReadonlySet<MentionItemType> = new Set([
  'image',
  'video',
  'text',
  'group',
]);
